export function transformBackendInstitution(backendItem: any): Institution {
    const id = backendItem.id ?? null;
    const name = backendItem.primaryName || backendItem.name || '';
    const country = backendItem.countryName || backendItem.country || '';
    const stateCode = backendItem.stateCode || backendItem.state || '';
    const city = backendItem.city || '';

    return {
        city: city || '',
        confirmed: backendItem.confirmed,
        country: country || '',
        countryCode: backendItem.countryCode,
        countryName: backendItem.countryName,
        custom: backendItem.custom || false,
        hitName: backendItem.hitName,
        id,
        matchedType: backendItem.matchedType,
        name,
        primaryName: backendItem.primaryName,
        remId: backendItem.remId,
        ringgoldId: backendItem.ringgoldIds?.[0],
        state: backendItem.state,
        stateCode: stateCode || '',
    };
}

export function extractInstitutionsFromResponse(response: any): any[] {
    console.log('[extractInstitutionsFromResponse] Raw response:', response);
    if (response?.status === 'SUCCESS' && response.payload) {
        if (response.payload.items && Array.isArray(response.payload.items)) {
            console.log(
                '[extractInstitutionsFromResponse] Extracted items from SUCCESS response:',
                response.payload.items.length,
            );
            return response.payload.items;
        }
        if (Array.isArray(response.payload)) {
            console.log('[extractInstitutionsFromResponse] Payload is array:', response.payload.length);
            return response.payload;
        }
        console.warn(
            '[extractInstitutionsFromResponse] Unrecognized payload structure in SUCCESS response:',
            response.payload,
        );
        return [];
    }

    if (response?.payload) {
        if (response.payload.items && Array.isArray(response.payload.items)) {
            return response.payload.items;
        }
        if (Array.isArray(response.payload)) {
            return response.payload;
        }
        return [];
    }

    if (response?.items && Array.isArray(response.items)) {
        return response.items;
    }

    if (Array.isArray(response)) {
        return response;
    }

    return [];
}

export function transformInstitutionList(backendItems: any[]): Institution[] {
    if (!Array.isArray(backendItems)) {
        console.warn('Expected array of institutions, got:', typeof backendItems);
        return [];
    }

    return backendItems.map(transformBackendInstitution);
}
